/** session_temp_upload.file_type and attached_file.file_type for user uploads */
export enum UploadedFileType {
  Office = 'office',
  Pdf = 'pdf',
  PlainText = 'plain_text',
  RegularImage = 'regular_image',
  PreparsedImage = 'preparsed_image',
}

export enum SessionUploadBucket {
  Temps = 'session-temps',
  Files = 'session-files',
}

export enum SessionUploadObjectVariant {
  Original = 'original',
  Parsed = 'parsed',
}

export enum SessionUploadErrorCode {
  FeatureDisabled = 'FEATURE_DISABLED',
  InvalidUpload = 'invalid_upload',
  UnsupportedExtension = 'unsupported_extension',
  InvalidUtf8 = 'invalid_utf8',
  ParseFailed = 'parse_failed',
  ImageDimensionsExceeded = 'image_dimensions_exceeded',
  InvalidUploadPath = 'invalid_upload_path',
  SessionQuotaExceeded = 'session_quota_exceeded',
  DuplicateTempUpload = 'duplicate_temp_upload',
  PromoteUploadNotFound = 'promote_upload_not_found',
  UploadAliasRequired = 'upload_alias_required',
  SessionRootProductMissing = 'session_root_product_missing',
}

export enum SessionUploadProductMetadataKind {
  UserAttachmentsCollection = 'user_attachments_collection',
  UserAttachedFile = 'user_attached_file',
}

export enum SessionUploadMimeType {
  Binary = 'application/octet-stream',
  ParsedText = 'text/plain; charset=utf-8',
  Pdf = 'application/pdf',
  Png = 'image/png',
  Jpeg = 'image/jpeg',
  Webp = 'image/webp',
  Gif = 'image/gif',
  Svg = 'image/svg+xml',
  Tiff = 'image/tiff',
  Bmp = 'image/bmp',
  Heic = 'image/heic',
  Heif = 'image/heif',
  Avif = 'image/avif',
  Ico = 'image/x-icon',
  Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  Odt = 'application/vnd.oasis.opendocument.text',
  Odp = 'application/vnd.oasis.opendocument.presentation',
  Ods = 'application/vnd.oasis.opendocument.spreadsheet',
  Rtf = 'application/rtf',
}

export enum SessionUploadEncoding {
  Utf8 = 'utf-8',
}

export enum SessionUploadRandomEncoding {
  Hex = 'hex',
}

export enum SessionUploadRuntimeErrorName {
  DomainError = 'DomainError',
}

export enum SessionUploadMultipartField {
  File = 'file',
}

export enum SessionUploadEntityLabel {
  TempUpload = 'TempUpload',
  ParsedTempUpload = 'ParsedTempUpload',
}

export enum SessionUploadOperation {
  PutTempUpload = 'putTempUpload',
  GetTempUpload = 'getTempUpload',
  ListTempUploadsForSession = 'listTempUploadsForSession',
  PromoteUploads = 'promoteUploads',
}

export enum SessionUploadAccessErrorMessage {
  TempUploadWrongUser = 'Temp upload does not belong to this user',
  TempUploadWrongSession = 'Temp upload does not belong to this session',
}

export enum SessionUploadApiMessage {
  FileUploadsDisabled = 'File uploads are disabled',
}

export enum SessionUploadPathToken {
  ExtensionSeparator = '.',
  ParsedInfix = '.parsed',
}

export enum SessionUploadProductText {
  UserAttachmentsCollectionName = 'User Attachments',
  UserAttachmentsCollectionDescription = 'Files the user has attached to collabs in this session.',
  UserAttachmentsCollectionDefinitionOfDone = 'User-uploaded attachments are available as child products.',
  UserAttachmentsCollectionSummary = 'User-uploaded attachments.',
  FileProductDefinitionOfDone = 'Attached file is stored and linked to this product.',
}

export enum UploadFileExtension {
  Docx = 'docx',
  Xlsx = 'xlsx',
  Pptx = 'pptx',
  Odt = 'odt',
  Odp = 'odp',
  Ods = 'ods',
  Rtf = 'rtf',
  Pdf = 'pdf',
  Jpg = 'jpg',
  Jpeg = 'jpeg',
  Png = 'png',
  Webp = 'webp',
  Gif = 'gif',
  Svg = 'svg',
  Tiff = 'tiff',
  Tif = 'tif',
  Bmp = 'bmp',
  Heic = 'heic',
  Heif = 'heif',
  Avif = 'avif',
  Ico = 'ico',
  Txt = 'txt',
  Md = 'md',
  Csv = 'csv',
  Tsv = 'tsv',
  Log = 'log',
  Js = 'js',
  Ts = 'ts',
  Tsx = 'tsx',
  Jsx = 'jsx',
  Json = 'json',
  Yaml = 'yaml',
  Yml = 'yml',
  Toml = 'toml',
  Ini = 'ini',
  Env = 'env',
  Html = 'html',
  Htm = 'htm',
  Css = 'css',
  Scss = 'scss',
  Sass = 'sass',
  Xml = 'xml',
  Sh = 'sh',
  Bash = 'bash',
  Zsh = 'zsh',
  Py = 'py',
  Rb = 'rb',
  Go = 'go',
  Rs = 'rs',
  Java = 'java',
  Kt = 'kt',
  Swift = 'swift',
  C = 'c',
  H = 'h',
  Cpp = 'cpp',
  Hpp = 'hpp',
  Cs = 'cs',
}
